import { Component, Input, OnInit } from '@angular/core';
import { ModalService } from 'src/app/services/commons/modal.service';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss'],
})
export class ConfirmComponent implements OnInit {

  @Input('modalTitle') modalTitle: string
  @Input('modalSubtitle') modalSubtitle: string;
  @Input('paramMainButton') paramMainButton: string;
  @Input('paramSecondButton') paramSecondButton: string;

  constructor(private modalService: ModalService) { }

  ngOnInit() {}

  dismiss(confirm: boolean) {
    this.modalService.hide('confirmModal', confirm);
  }


}
